import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1d2b4557"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-container" }
const _hoisted_2 = { class: "title-search-bar-container" }
const _hoisted_3 = { class: "title font-weight-black" }
const _hoisted_4 = { class: "search-bar-filter-toggle-container" }
const _hoisted_5 = { class: "search-bar-container" }
const _hoisted_6 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "date-picker-container d-flex justify-center" }
const _hoisted_9 = { class: "v-select-container" }
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 1,
  class: "text-caption text-medium-emphasis device-selection-more"
}
const _hoisted_12 = {
  key: 0,
  class: "action-button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_date_input = _resolveComponent("v-date-input")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_text_field, {
            class: "search-bar",
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.$t('i18n.searchBarPlaceholder'),
            onInput: _ctx.handleSearchQueryChange,
            "prepend-inner-icon": "mdi-magnify",
            "hide-details": "",
            "single-line": "",
            variant: "outlined",
            density: "compact"
          }, null, 8, ["modelValue", "placeholder", "onInput"])
        ]),
        _createVNode(_component_v_btn, {
          class: "cursor-pointer",
          variant: "text",
          size: "small",
          icon: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilterToolbar = !_ctx.showFilterToolbar))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { icon: "mdi-filter" }),
            (!_ctx.showFilterToolbar)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.showFilterToolbar')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showFilterToolbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('i18n.filters')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_locale_provider, { locale: "pt" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_date_input, {
                  "onClick:clear": _ctx.clearDateRange,
                  "prepend-icon": "",
                  "prepend-inner-icon": "$calendar",
                  modelValue: _ctx.selectedDateRange,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDateRange) = $event)),
                    _ctx.handleSelectedDateRange
                  ],
                  label: _ctx.$t('i18n.datePickerLabel'),
                  placeholder: _ctx.$t('i18n.datePickerPlaceholder'),
                  "ok-text": _ctx.$t('i18n.datePickerOk'),
                  "cancel-text": _ctx.$t('i18n.datePickerCancel'),
                  "min-width": "18em",
                  multiple: "range",
                  "hide-details": "auto",
                  variant: "outlined",
                  density: "compact",
                  color: "black",
                  "single-line": "",
                  clearable: "",
                  "clear-icon": "mdi-close-circle",
                  max: _ctx.maxDate
                }, null, 8, ["onClick:clear", "modelValue", "label", "placeholder", "ok-text", "cancel-text", "max", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "start"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('i18n.datePicker')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedDeviceIds,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDeviceIds) = $event)),
                _ctx.handleSelectedDeviceIdsChange
              ],
              "item-props": _ctx.deviceItemProps,
              items: _ctx.deviceList,
              clearable: "",
              "prepend-inner-icon": "mdi-tablet-cellphone",
              placeholder: _ctx.$t('i18n.tabletLocationPlaceholder'),
              multiple: "",
              "hide-details": "auto",
              variant: "outlined",
              density: "compact"
            }, {
              selection: _withCtx(({ item, index }) => [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "device-selection-text",
                      title: String(item.title)
                    }, _toDisplayString(item.title), 9, _hoisted_10))
                  : (index === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (" + _toDisplayString(_ctx.additionalSelectedDevicesLabel(_ctx.selectedDeviceIds.length - 1)) + ") ", 1))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue", "item-props", "items", "placeholder"])
          ]),
          (_ctx.newPendingFilters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  class: "gorate-btn-bg",
                  rounded: "xl",
                  variant: "flat",
                  onClick: _ctx.handleApplyFiltersClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.apply')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}